import HomePageV2 from './PageComponents/Home'

export { default as LandingPageV2Layout } from './Layout'

export default HomePageV2
